import React from 'react';
import logo from '../assets/logo.png';

const Loader = ({ message = null, className = "", fullPage = false, size = "md" }) => {
  const sizeClasses = {
    xs: "w-4 h-4 border-2",
    sm: "w-6 h-6 border-2",
    md: "w-10 h-10 border-[3px]",
    lg: "w-24 h-24 border-4"
  };

  if (size === "xs" || size === "sm") {
    return (
      <div className={`${fullPage ? "fixed inset-0 z-50 bg-white/60 backdrop-blur-sm" : ""} flex items-center justify-center ${className}`}>
        <div className={`${sizeClasses[size]} border-indigo-100/30 border-t-indigo-600 rounded-full animate-spin`}></div>
      </div>
    );
  }

  return (
    <div className={`${fullPage ? "fixed inset-0 z-50 bg-white/60 backdrop-blur-sm" : ""} flex flex-col items-center justify-center ${message ? "min-h-[200px]" : ""} h-full w-full ${className}`}>
      <div className="relative flex items-center justify-center">
        {/* Animated Background Glow */}
        <div className={`absolute ${size === 'lg' ? 'w-32 h-32' : 'w-16 h-16'} rounded-full blur-2xl opacity-20 animate-pulse-fast bg-indigo-600`}></div>

        {/* Main outer ring */}
        <div className={`${sizeClasses[size]} border-indigo-100/30 border-t-indigo-600 rounded-full animate-spin shadow-lg`}></div>
        
        {/* Middle ring rotating opposite */}
        <div className={`absolute ${size === 'lg' ? 'w-20 h-20' : 'w-8 h-8'} border-[3px] border-transparent border-t-indigo-400 rounded-full animate-spin-reverse opacity-80`}></div>

        {/* Inner ring */}
        <div className={`absolute ${size === 'lg' ? 'w-16 h-16' : 'w-6 h-6'} border-[3px] border-transparent border-b-indigo-300 rounded-full animate-spin-slow opacity-60`}></div>
        
        {/* App Icon in the center */}
        <div className="absolute flex items-center justify-center animate-float">
          <img 
            src={logo} 
            alt="App Icon" 
            className={`${size === 'lg' ? 'w-10 h-10' : 'w-4 h-4'} object-contain drop-shadow-md animate-pulse-fast`} 
          />
        </div>
      </div>
      
      {message && (
        <div className="mt-8 flex flex-col items-center animate-bounce-slow">
          <p className="text-xl font-bold tracking-widest uppercase italic text-indigo-600">
            {message}
          </p>
          <div className="flex space-x-2 mt-3">
            <div className="w-2 h-2 bg-indigo-500 rounded-full animate-bounce [animation-delay:-0.3s] shadow-sm"></div>
            <div className="w-2 h-2 bg-indigo-500 rounded-full animate-bounce [animation-delay:-0.15s] shadow-sm"></div>
            <div className="w-2 h-2 bg-indigo-500 rounded-full animate-bounce shadow-sm"></div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Loader;
